import { render, staticRenderFns } from "./HeaderSettings.vue?vue&type=template&id=10d3e38e&scoped=true&"
import script from "./HeaderSettings.vue?vue&type=script&lang=js&"
export * from "./HeaderSettings.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSettings.vue?vue&type=style&index=0&id=10d3e38e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d3e38e",
  null
  
)

export default component.exports